import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader } from '@mui/material';
import { LineChart } from '@mui/x-charts/LineChart';
import { 
  green, 
  blue, 
  orange, 
  purple, 
  blueGrey, 
  brown, 
  deepOrange 
} from '@mui/material/colors';

import { OriginatedByChannel } from '@bandido/shared/types';
import { GetDashboardInfoDto } from '@bandido/shared/dtos';

import { useGetCasesByHourAndChannel } from '../hooks/queries';
import { generateFullDayHours } from '../utils';

dayjs.extend(duration);

export const CasesByHourAndChannelGraph = ({ startDate, endDate, agencyIds }: GetDashboardInfoDto) => {
  const { t } = useTranslation();
  const { data } = useGetCasesByHourAndChannel({ startDate, endDate, agencyIds });

  if (!data?.data) return null;

  const chartData = generateFullDayHours(data.data);

  return (
    <Card>
      <CardHeader title={t('dashboard.casesByHourAndChannel')} />
      <CardContent>
        <LineChart
          xAxis={[{ data: chartData.map((d) => dayjs(d.hour).format('HH:mm')), scaleType: 'band' }]}
          series={[
            {
              data: chartData.map((d) => d[OriginatedByChannel.WHATSAPP]),
              label: t('dashboard.channels.whatsapp'),
              color: green[400], // #66bb6a - Verde suave
            },
            {
              data: chartData.map((d) => d[OriginatedByChannel.CALL]),
              label: t('dashboard.channels.call'),
              color: blue[400], // #42a5f5 - Azul suave
            },
            {
              data: chartData.map((d) => d[OriginatedByChannel.EMAIL]),
              label: t('dashboard.channels.email'),
              color: orange[400], // #ffa726 - Naranja suave
            },
            {
              data: chartData.map((d) => d[OriginatedByChannel.EXTERNAL_INTEGRATION]),
              label: t('dashboard.channels.externalIntegration'),
              color: blueGrey[400], // #78909c - Gris azulado suave
            },
            {
              data: chartData.map((d) => d[OriginatedByChannel.MANUAL]),
              label: t('dashboard.channels.manual'),
              color: purple[400], // #ab47bc - Púrpura suave
            },
            {
              data: chartData.map((d) => d[OriginatedByChannel.UPLOADED]),
              label: t('dashboard.channels.uploaded'),
              color: brown[400], // #8d6e63 - Marrón suave
            },
            {
              data: chartData.map((d) => d[OriginatedByChannel.SUPPORT_FORM]),
              label: t('dashboard.channels.supportForm'),
              color: deepOrange[400], // #ff7043 - Naranja profundo suave
            },
          ]}
          height={400}
        />
      </CardContent>
    </Card>
  );
};

export default CasesByHourAndChannelGraph;
